import { apiRequest, ApiResponse } from '../request'
import {
    Policy,
    PolicyType,
    PolicyStatus,
    CreatePolicyDto,
    UpdatePolicyDto,
} from '../common/interfaces/policy.interface'

export interface PoliciesFilters {
    type?: PolicyType
    status?: PolicyStatus
    search?: string
    page?: number
    limit?: number
    sortBy?: string
    sortOrder?: string
}

export async function getPolicies(
    filters?: PoliciesFilters,
): Promise<ApiResponse<Policy[]>> {
    const params: Record<string, any> = {}

    if (filters?.type) params.type = filters.type
    if (filters?.status) params.status = filters.status
    if (filters?.search) params.search = filters.search
    if (filters?.page) params.page = filters.page
    if (filters?.limit) params.limit = filters.limit
    if (filters?.sortBy) params.sortBy = filters.sortBy
    if (filters?.sortOrder) params.sortOrder = filters.sortOrder

    return apiRequest<Policy[]>('policies', { params }, 'get')
}

export async function getPolicy(
    id: number,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(`policies/${id}`, {}, 'get')
}

export async function getPolicyByType(
    type: PolicyType,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(`policies/type/${type}`, {}, 'get')
}

export async function createPolicy(
    data: CreatePolicyDto,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>('policies', { data }, 'post')
}

export async function updatePolicy(
    id: number,
    data: UpdatePolicyDto,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(`policies/${id}`, { data }, 'patch')
}

export async function publishPolicy(
    id: number,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(`policies/${id}/publish`, {}, 'post')
}

export async function unpublishPolicy(
    id: number,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(`policies/${id}/unpublish`, {}, 'post')
}

export async function sendToAnalysis(
    id: number,
): Promise<ApiResponse<Policy>> {
    return apiRequest<Policy>(
        `policies/${id}/send-to-analysis`,
        {},
        'post',
    )
}

export async function deletePolicy(
    id: number,
): Promise<ApiResponse<{ message: string }>> {
    return apiRequest<{ message: string }>(
        `policies/${id}`,
        {},
        'delete',
    )
}
